module.exports = __webpack_public_path__ + "static/media/41.e4f03159.jpg";